import { lazy } from 'react';

import { RichText } from '@login/components/rich-text';

import styles from './api-error-block.module.scss';

const InfoBlock = lazy(() => import('core/generic/elements/info-block'));

type ApiErrorBlockProps = {
	apiErrorMessage: string;
};

export const ApiErrorBlock = ({ apiErrorMessage }: ApiErrorBlockProps) => {
	if (!apiErrorMessage) return null;

	return (
		<InfoBlock variant="error">
			<div className={styles['error-info-block']}>
				<p className="body-small">
					<RichText
						text={apiErrorMessage}
						linkClassName={styles['inline-button']}
					/>
				</p>
			</div>
		</InfoBlock>
	);
};

export default ApiErrorBlock;
